(() => {
  const translations = {
    de: {
      heading: 'Wir respektieren deine Privatsphäre',
      message: 'Diese Website verwendet Cookies, um Dir das beste Shopping-Erlebnis zu bieten.',
      more: 'Mehr erfahren',
      okay: 'Okay',
      close: 'Schließen',
    },
    en: {
      heading: 'We respect your privacy',
      message: 'This website uses cookies to give you the best shopping experience.',
      more: 'Learn more',
      okay: 'OK',
      close: 'Close',
    },
    fr: {
      heading: 'Nous respectons votre vie privée',
      message: 'Ce site utilise des cookies pour vous offrir la meilleure expérience d’achat.',
      more: 'En savoir plus',
      okay: 'D’accord',
      close: 'Fermer',
    },
    it: {
      heading: 'Rispettiamo la tua privacy',
      message: 'Questo sito utilizza i cookie per offrirti la migliore esperienza di acquisto.',
      more: 'Scopri di più',
      okay: 'Va bene',
      close: 'Chiudi',
    },
    nl: {
      heading: 'We respecteren je privacy',
      message: 'Deze website gebruikt cookies om je de beste winkelervaring te bieden.',
      more: 'Meer informatie',
      okay: 'Oké',
      close: 'Sluiten',
    },
    es: {
      heading: 'Respetamos tu privacidad',
      message: 'Este sitio web utiliza cookies para ofrecerte la mejor experiencia de compra.',
      more: 'Más información',
      okay: 'Vale',
      close: 'Cerrar',
    },
  };

  const language = document.documentElement.lang.toLowerCase().split('-')[0];
  const translation = translations[language];
  if (!translation) return;
  const privacyUrl = `${window.location.origin}${language === 'de' ? '' : `/${language}`}/policies/privacy-policy`;

  let currentBanner;
  let bannerObserver;

  const translateBanner = () => {
    const message = currentBanner.querySelector('.cc-message');
    const button = currentBanner.querySelector('.cc-btn-decision.cc-dismiss');
    if (!message || !button) return;

    const messageText = Array.from(message.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
    if (messageText && messageText.textContent.trim() !== translation.message) {
      messageText.textContent = `${translation.message} `;
    }

    const link = message.querySelector('.cc-link');
    if (link && link.textContent !== translation.more) link.textContent = translation.more;
    if (link && link.href !== privacyUrl) link.href = privacyUrl;
    if (button.textContent !== translation.okay) button.textContent = translation.okay;
    if (currentBanner.getAttribute('aria-label') !== translation.heading) {
      currentBanner.setAttribute('aria-label', translation.heading);
    }

    const close = currentBanner.querySelector('.cc-close');
    if (close && close.getAttribute('aria-label') !== translation.close) {
      close.setAttribute('aria-label', translation.close);
    }
  };

  const watchBanner = () => {
    const banner = document.getElementById('pandectes-banner');
    if (!banner || banner === currentBanner) return;

    bannerObserver?.disconnect();
    currentBanner = banner;
    bannerObserver = new MutationObserver(translateBanner);
    bannerObserver.observe(banner, { childList: true, characterData: true, subtree: true });
    translateBanner();
  };

  const rootObserver = new MutationObserver(watchBanner);
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });
  watchBanner();
})();
